import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-consultant',
  templateUrl: './consultant.component.html',
  styleUrls: ['./consultant.component.css']
})
export class ConsultantComponent implements OnInit {

  constructor(private router: Router,public global: Globals,translate: TranslateService) {
    translate.setDefaultLang('AR');
  }

  ngOnInit() {
  }

}
